module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-liftHome"
  }, [_vm._m(0), _c('div', {
    staticClass: "module2"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case8"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img20.jpg")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.08")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("不请设计师，魔都小两口玩转91㎡两房，软装配色美出天际")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case7"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img19.jpg")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.07")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("65㎡精致小户型，处女座男生的神仙日子")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case6"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img2.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.06")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("设计师爆改上海50㎡老房，示范小户型改造神操作")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case5"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img3.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.05")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海93㎡萌趣三口之家，每天都像生活在游乐场")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case4"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img4.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.04")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海市区一套房，郊外一栋度假屋，生活这样真挺好！")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case3"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img5.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.03")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case2"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img6.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.02")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海246㎡精装大平层，用家具与配饰沉淀出家的味道")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case1"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/img7.png")
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.01")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子")])])], 1), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝客户的家"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("对家居审美有追求、对生活品质不将就，懂窝客户的家，是我们最好的样板房。"), _c('br'), _vm._v(" 记录懂窝产品搭配出的丰富生活场景，更记录每个寻常人家的温馨故事。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("晒单活动"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("热爱分享是热爱生活的体现，记录生活点滴时刻，启发更多家居灵感。"), _c('br'), _vm._v(" 懂窝生活家们，欢迎与我们联系，拍下懂窝产品在您家的使用场景，秀出你的生活你的家。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/icon1.png")
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_vm._v("途径1：通过"), _c('span', [_vm._v("天猫晒图")]), _vm._v("，并将相同内容发布到逛逛"), _c('br'), _vm._v("途径2：通过"), _c('span', [_vm._v("小红书晒图并@懂窝")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/icon2.png")
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_vm._v("天猫："), _c('span', [_vm._v("15字以上+3张以上美图/视频")]), _c('br'), _vm._v("小红书："), _c('span', [_vm._v("50字以上+3张以上美图/视频")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/icon3.png")
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("文字内容生动，能凸显懂窝产品特性")]), _c('br'), _c('span', [_vm._v("图片美观，构图清晰，能体现懂窝产品特点")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/icon4.png")
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("天猫晒单：将晒单截图给天猫客服，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。")]), _c('br'), _c('span', [_vm._v("其他渠道晒单：将晒单截图给对接搭配师，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img1.jpg")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @华先生")]), _c('br'), _vm._v(" 伊丽莎白Elizabeth沙发"), _c('br'), _vm._v(" 娜塔莎Natasha双人床"), _c('br'), _vm._v("巴罗Barrow沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img2.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @Tracy")]), _c('br'), _vm._v("莱拉 Leila 书桌")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img3.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @h**y")]), _c('br'), _vm._v(" 丹维尔Danville沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img4.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @赵小姐")]), _c('br'), _vm._v(" 瑞森Riesen餐椅"), _c('br'), _vm._v(" 彭特Puente餐桌")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img5.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @赵女士")]), _c('br'), _vm._v(" 巴罗Barrow沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s1-img6.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @周小姐")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/s2-img1.jpg")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @陈小姐")]), _c('br'), _vm._v(" 弗雷德里克 Frederik 沙发 "), _c('br'), _vm._v(" 海尔格 Helgar 羽毛落地灯")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s2-img2.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @香り")]), _c('br'), _vm._v(" 艾尔弗雷德 Alfred 地灯")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s2-img3.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @宫小姐")]), _c('br'), _vm._v(" 普莱森顿 Pleasanton 沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s2-img4.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @李小姐")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s2-img5.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @孙女士")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img1.jpg")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @罗小姐 ")]), _c('br'), _vm._v(" 杰洛德Jarrod布艺沙发 "), _c('br'), _vm._v(" 琳内尔Linnell双人床")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img2.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v("  @Bingxin ")]), _c('br'), _vm._v("  巴罗 Barrow 沙发 "), _c('br'), _vm._v(" 拉里亚 Llaria 地灯")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img3.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @欧先生 ")]), _c('br'), _vm._v(" 普莱森顿 Pleasanton 沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img4.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @陈先生 ")]), _c('br'), _vm._v(" 巴罗 Barrow 沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img5.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @王女士 ")]), _c('br'), _vm._v(" 巴罗 Barrow 沙发")]), _c('img', {
    attrs: {
      "src": require("assets/lifeHome/s3-img6.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @郑女士 ")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户口碑反馈"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("口碑源于产品和服务，懂窝成立以来深受客户喜爱，在小红书、大众"), _c('br'), _vm._v("点评等平台拥有超高人气口碑，连续位列大众点评上海地区成品家具前三。感谢您的反馈，帮助我们持之以恒做得更好。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/swiper1.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/swiper2.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/swiper3.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/swiper4.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/lifeHome/swiper5.png")
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ab1afe"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lifeHome.vue
// module id = 449
// module chunks = 0